import React, { useEffect, useState, useRef } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  IconButton,
  Box,
  Grid,
} from "@mui/material";
import ButtomCustom from "../../ButtonRound";

import { useSelector } from "react-redux";
import HttpClient from "../../../helpers/HttpClient";
import { showToast } from "../../../utils/toast";
import { useInterval } from "../../../hooks/useInterval";
import OverlayLoader from "../../OverlayLoader";

const VocabularyTable = ({
  data,
  type,
  courseCode,
  onFinalize,
  onContinue,
}) => {
  const [openLoader, setOpenOpenLoader] = useState(false);
  const [count, setCount] = useState(0);
  const [delay, setDelay] = useState(1000);
  const [isPlaying, setPlaying] = useState(false);
  const durationFromDB = useRef(false);
  const authState = useSelector((state) => state.auth);
  const [vocabularyAr, setVocabularyAr] = useState([]);
  const [isSaved, setIsSaved] = useState(false);
  const DEFAULT_DURATION_SUBLESSONS_SECONDS = 30;
  const sublessonDuration = useRef(DEFAULT_DURATION_SUBLESSONS_SECONDS);
  const userId =
    authState && authState.user ? authState.user.email : "test";

  useInterval(
    () => {
      setCount(count + 1);
    },
    isPlaying && !isSaved ? delay : null
  );

  const loadData = async () => {
    console.log("ING1_0010_0040", data.cod_leccion);
    const request = await HttpClient().get(
      `/step/exercise-data/${userId}/${courseCode}/VOC_PRA/${data.cod_leccion}`
    );

    if (request.error) {
      showToast("No se pudo cargar información. Intenta nuevamente.", "error");
      return;
    }
    const orderedList = request.data.sort((a, b) => {
      a = a.frase.toLowerCase().replace(/ /g, "");
      b = b.frase.toLowerCase().replace(/ /g, "");
      if (a == b) {
        return 0;
      }
      if (a < b) {
        return -1;
      }
      return 1;
    });
    setVocabularyAr(orderedList);
    sublessonDuration.current = DEFAULT_DURATION_SUBLESSONS_SECONDS;
    if (
      data.duracion_minima_segundos != null &&
      Number(data.duracion_minima_segundos)
    ) {
      sublessonDuration.current = Number(data.duracion_minima_segundos);
      durationFromDB.current = true;
    }
  };

  const insertView = async () => {
    if (type == "SUBLESSON") {
      const request = await HttpClient().post(
        `/lessons/save-sublesson/${userId}/${data.id}`,
        {}
      );
      setIsSaved(true);
      onFinalize();
    }

    if (type == "LESSON" && data.operativa == 1) {
      const request = await HttpClient().post(
        `/lessons/save-lesson/${userId}/${data.cod_leccion}`,
        {}
      );
      setIsSaved(true);
      onFinalize();
    }
  };
  useEffect(() => {
    setIsSaved(false);
    setPlaying(false);
    setCount(0);
    if (data) {
      setOpenOpenLoader(true);
      loadData();
      document.getElementsByClassName("main")[0].scrollTo({ top: 0, left: 0 });
      setOpenOpenLoader(false);
      setPlaying(true);
    }
  }, []);

  useEffect(() => {
    if (count > 0) {
      let readyTimeOther = true;

      if (
        count < sublessonDuration.current ||
        count > sublessonDuration.current
      ) {
        readyTimeOther = false;
      }

      if (readyTimeOther == true) {
        setPlaying(false);
        setCount(0);
        insertView();
      }
    }
  }, [count]);
  return (
    <Box
      sx={{
        maxWidth: "900px",
        maxHeight: "calc(100vh - 250px)",
        margin: "auto",
        mt: 5,
        p: 3,
        borderRadius: 2,
        boxShadow: 3,
      }}
    >
      <OverlayLoader open={openLoader} />
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <Typography variant="h6" color="primary" sx={{ ml: 1 }}>
          {data.contenido}
        </Typography>
      </Box>
      <TableContainer
        component={Paper}
        sx={{ overflowY: "auto", maxHeight: "calc(100vh - 400px)" }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell align="center" sx={{ fontWeight: "bold" }}>
                VOCABULARY
              </TableCell>
              <TableCell align="center" sx={{ fontWeight: "bold" }}>
                MEANING
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {vocabularyAr.map((row, index) => (
              <TableRow key={index}>
                <TableCell align="center">{row.frase}</TableCell>
                <TableCell align="center">{row.traduccion}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <input type={"hidden"} value={isSaved} id={"input-hidden-saved"} />
      <input type={"hidden"} value={isPlaying} id={"input-hidden-is-playing"} />
      <Grid item xs={12} className="lessons-button-container-center">
        <ButtomCustom
          sx={{ marginTop: 1 }}
          onClick={() => {
            onContinue();
          }}
          variant="contained"
          rounded
        >
          Continuar
        </ButtomCustom>
      </Grid>
    </Box>
  );
};

export default VocabularyTable;
